export class DeleteProjectINModel {
    idProgetto: number
}